import DepartmentGrids from "./DepartmentsGrid";
import Testimonials from "@/components/cta/CTATestimonials";
import HeroVideoWebM from "./HeroVideoWebM";
import { Section } from "@/components/ui/section";
import { ScrollContainer } from "@/components/ui/scroll-container";
import { CTAGeneric } from "@/components/cta/"
import ScrollIndicator from "@/components/ui/scroll-indicator";
// import CarouselIndustry from "@/components/elements/carousel/CarouselIndustry";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

/* eslint-disable jsx-a11y/anchor-is-valid */
export default function HomePage() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <main className="w-screen overflow-y-scroll overflow-x-hidden bg-black z-0 no-scrollbar">
            <ScrollContainer snapType="y" snapBehavior="mandatory">
                <Section
                    fullHeight={true}
                    scrollSnap={true}
                    variant="dark"
                    padding="none"
                    contained={false}
                >
                    <HeroVideoWebM />
                </Section>

                {/* Carousel section */}

                {/* <Section
                    scrollSnap={true}
                    variant="default"
                    padding="none"
                    contained={false}
                >
                    <CarouselIndustry
                        heading="Industries We Serve — Design 1"
                        subheading="Tailored solutions for every sector — from hospitality to education, aged care to construction."
                        headingLevel="h2"
                        menuName="Industry"
                        variant="default"
                    />
                </Section> */}
                

                <Section
                    scrollSnap={true}
                    variant="light"
                    padding="xl"
                    contained={false}
                    overlayColor="transparent"
                >
                    <div className="relative">
                        {/* Background decorative elements */}
                        <div className="absolute inset-0 overflow-hidden pointer-events-none">
                            <div className="absolute -top-24 -left-24 w-48 h-48 bg-gradient-to-br from-red-500/5 to-gray-900/5 rounded-full blur-3xl"></div>
                            <div className="absolute -bottom-12 -right-12 w-64 h-64 bg-gradient-to-tl from-red-600/3 to-gray-800/3 rounded-full blur-3xl"></div>
                        </div>

                        {/* Main content */}
                        <div className="relative z-10 text-center max-w-6xl mx-auto">
                            {/* Section badge */}
                            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-red-50 to-gray-50 border border-red-100 rounded-full px-6 py-2 mb-8">
                                <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                                <span className="text-sm font-medium text-gradient-red uppercase tracking-wider">What We Do</span>
                            </div>

                            {/* Main headline with gradient - combined messaging */}
                            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 leading-tight">
                                <span className="text-gray-900">Shaping Exceptional Spaces</span>{' '}
                                <br />
                                <span className="hero-text-gradient-red">
                                    Commercial & Residential
                                </span>
                            </h1>

                            {/* Enhanced description */}
                            <div className="max-w-4xl mx-auto mb-12">
                                <p className="text-xl md:text-2xl text-gray-700 leading-relaxed mb-6">
                                    Everything you need is <span className="font-semibold text-gradient-red">under one roof.</span>
                                </p>
                                <p className="text-lg text-gray-600 leading-relaxed">
                                    We supply a wide range of quality appliances, furniture, and bedding from trusted brands, with options to suit every budget. Whether you're planning a large-scale development or a one-off fit-out, our team delivers tailored solutions and reliable support from start to finish.
                                </p>
                            </div>
                            {/* Call-to-action with scroll indicator */}
                            <div className="flex flex-col items-center">
                                <ScrollIndicator />
                            </div>
                        </div>
                    </div>
                </Section>

                <Section
                    scrollSnap={true}
                    variant="default"
                    padding="none"
                    contained={false}
                >
                    <DepartmentGrids />
                </Section>

                <Section
                    scrollSnap={true}
                    variant="default"
                    padding="none"
                    contained={false}
                >
                    <Testimonials />
                </Section>

                <Section
                    scrollSnap={true}
                    variant="default"
                    padding="none"
                    contained={false}
                >
                    <CTAGeneric title="Have a Question or Enquiry?" description="Let our business specialist help you. We are here to answer any questions you might have." />
                </Section>

            </ScrollContainer>
        </main>
    )
}